import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, withModifiers as _withModifiers, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, isRef as _isRef, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/head1.png'
import _imports_1 from '../../assets/head2.png'
import _imports_2 from '../../assets/head5.png'
import _imports_3 from '../../assets/head6.png'


const _withScopeId = n => (_pushScopeId("data-v-5d9e21eb"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "wrist-watch-home"
}
const _hoisted_2 = { class: "wrist-watch-header" }
const _hoisted_3 = { class: "status-wrapper" }
const _hoisted_4 = { class: "icon-wrapper" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "statusText" }
const _hoisted_7 = { class: "title" }
const _hoisted_8 = { class: "status" }
const _hoisted_9 = { class: "content" }
const _hoisted_10 = { class: "content" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "head" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "inline" }),
  /*#__PURE__*/_createElementVNode("span", { class: "headText" }, "当前套餐")
], -1))
const _hoisted_12 = { class: "flowContentWrapper" }
const _hoisted_13 = { class: "flowContent" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("text", { class: "flowTitle" }, "本月流量余量", -1))
const _hoisted_15 = { class: "content" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "unit" }, "流量/M", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flowInline" }, null, -1))
const _hoisted_18 = { class: "flowContent" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("text", { class: "flowTitle" }, "本月流量总量", -1))
const _hoisted_20 = { class: "content" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "unit" }, "流量/M", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "head" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "inline" }),
  /*#__PURE__*/_createElementVNode("span", { class: "headText" }, "功能界面")
], -1))
const _hoisted_23 = { class: "featureList" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_25 = { class: "clerk" }
const _hoisted_26 = ["onClick"]
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "clerk" }, "充值缴费", -1))
const _hoisted_29 = [
  _hoisted_27,
  _hoisted_28
]
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: ""
}, null, -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "clerk" }, "在线客服", -1))
const _hoisted_32 = [
  _hoisted_30,
  _hoisted_31
]
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: ""
}, null, -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "clerk" }, "专属客服", -1))
const _hoisted_35 = [
  _hoisted_33,
  _hoisted_34
]
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "popupTitle" }, "长按识别进入小程序", -1))
const _hoisted_37 = ["src"]
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "popupTitle" }, "添加一对一专属客服", -1))
const _hoisted_39 = ["src"]
const _hoisted_40 = ["src"]
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "popupTitle" }, "手机号校验", -1))
const _hoisted_42 = { style: {"margin":"16px"} }
const _hoisted_43 = ["src", "onClick"]
const _hoisted_44 = ["src"]

import { computed, onBeforeUnmount, onMounted, ref } from 'vue'
  import dxIcon from '@/assets/dx_icon.png'
  import ltIcon from '@/assets/lt_icon.png'
  import ydIcon from '@/assets/yd_icon.png'
  import appletImg from '@/assets/noapplet.png'
  import {
    getWifiCustomizationCardQueryCardMsg,
    getWifiCustomizationCardRealName,
    getWifiCustomizationCardSendCode,
    getWifiLoginAuth,
    getCheckCode,
    getOrderList,
    getWatchExperienceInfo,
    postOrderExperience
  } from '@/api'
  import { useRoute, useRouter } from 'vue-router'
  import { showDialog, showToast } from "vant";
  import store from '@/store'
  import { getRealNameAction, shouldPromptRealName } from '@/utils/realNameAccess'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

  const route = useRoute()
  const router = useRouter()

  const appletStatus = ref(false)
  const officialStatus = ref(false)
  const phoneStatus = ref(false)
  const realNameQrStatus = ref(false)
  const realNameQrUrl = ref('')
  const cardDataLoaded = ref(false)
  const cardData: any = ref({})
  let code = ref('');
  let phone = ref('');

  const operatorMap: Record<number, { name: string; icon: string }> = {
    1: { name: '中国移动', icon: ydIcon },
    2: { name: '中国联通', icon: ltIcon },
    3: { name: '中国电信', icon: dxIcon },
    4: { name: '中国电信', icon: dxIcon }
  }

  const operatorInfo = computed(() => {
    return operatorMap[Number(cardData.value?.operator)] || { name: '未知运营商', icon: dxIcon }
  })

  // 需要显示"设备管理"的域名白名单，按需增减
  const DEVICE_MANAGE_DOMAINS = [
    'mxtcloud.net',
    'pay.simware.cn',
    'charger.simware.cn',
    'wx.chengtaotoy.com',
    'wx.tinyguard.cn',
    // 'example.com',  // 在此添加更多域名
  ]

  // 精确匹配主域名或其子域名，避免 includes 误判（如 notmxtcloud.net）
  const isDeviceManageHost = (hostname: string) =>
    DEVICE_MANAGE_DOMAINS.some(
      domain => hostname === domain || hostname.endsWith(`.${domain}`)
    )

  const watchManageLabel = computed(() => {
    return isDeviceManageHost(window.location.hostname) ? '设备管理' : '手表管理'
  })

  const miniAppQrCodeUrl = computed(() => {
    const url = cardData.value.watchMiniAppQrCodeUrl
    return url || appletImg
  })

  const goKf = () => {
    window.location.href = sessionStorage.getItem('kfUrl') as string; //'https://work.weixin.qq.com/kfid/kfce4ad33084a66a45d?enc_scene=ENC7FG6s6ataZAgJpw6cnJYzKZaMri7LGFqxmtyAG2ZgvzL'
  }

  const goPackage = () => {
    router.push({
      name: 'packageList',
      params: {
        iccid: route.params.iccid,
        phone: cardData.value.iccidShort,
        status: cardData.value.cardStatus || '未知',
        operator: cardData.value.operator || ''
      }
    })
  }

  const phoneRule = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
  const sendCodeButtonText = ref<string>('发送验证码')

  const setIntervalTimer = () => {
    let timerout = 60
    sendCodeButtonText.value = `${timerout}秒后重试`
    const timer = setInterval(() => {
      timerout --;
      sendCodeButtonText.value = `${timerout}秒后重试`
      if (timerout <= 0) {
        sendCodeButtonText.value = "发送验证码";
        clearInterval(timer);
      }
    }, 1000);
  }

  const experienceStatus = ref(false)
  const experienceAlert = ref(false)
  const claim = () => {
    let data = {
      iccid: route.params.iccid,
      packageId: agentPackageResultVO.value.packageId
    }
    postOrderExperience(data)
      .then((res: any) => {
        if (res.code === 200) {
          experienceStatus.value = false
          experienceAlert.value = true
        }
      })
  }

  const getCode = () => {
    if (!phoneRule.test(phone.value)) {
      showToast({ message: "请输入正确的手机号", forbidClick: true, });
      return;
    }
    getWifiCustomizationCardSendCode({ mobile: phone.value })
      .then((res: any) => {
        if (res.code === 200) {
          showToast({ message: "验证码发送成功", forbidClick: true, });
          setIntervalTimer()
        } else {
          showToast({ message: res.message, forbidClick: true, });
        }
      })
  }

  const onSubmit = () => {
    let params = {
      mobile: phone.value,
      code: code.value,
      iccid: route.params.iccid
    }
    getCheckCode(params)
      .then((res: any) => {
        if (res.code === 200) {
          phoneStatus.value = false;
          localStorage.setItem('watchPhone', phone.value)
          promptRealNameIfNeeded(cardData.value)
        } else {
          showToast({ message: res.message, forbidClick: true, });
        }
      })
  };

  // 获取体验包信息
  let agentPackageResultVO: any = ref()
  const obtainSampleInfo = () => {
    let params = {
      iccid: route.params.iccid,
    }
    getWatchExperienceInfo(params)
      .then((res: any) => {
        if (res.code === 200) {
          experienceStatus.value = res.result?.experiencePackagePop || false
          agentPackageResultVO.value = res.result?.agentPackageResultVO
        }
      })
  }

  const continueWatchHome = () => {
    if (localStorage.getItem("watchPhone")) {
      obtainSampleInfo()
    } else {
      phoneStatus.value = true
    }
  }

  const promptRealNameIfNeeded = (card: any) => {
    getOrderList({ iccid: route.params.iccid }).then((orderRes: any) => {
      const orders = orderRes?.code === 200 && Array.isArray(orderRes.result) ? orderRes.result : []
      if (!shouldPromptRealName(card, orders)) {
        continueWatchHome()
        return
      }

      showDialog({
      title: '请完成实名认证',
      message: '当前卡片需要实名认证，完成认证后才能正常使用相关服务。',
      showCancelButton: true,
      confirmButtonText: '去实名认证',
      cancelButtonText: '稍后再说'
      }).then(() => {
      getWifiCustomizationCardRealName({ iccid: route.params.iccid })
        .then((res: any) => {
          if (res.code !== 200 || !res.result?.url) {
            showToast({ message: res.message || '获取实名认证入口失败', forbidClick: true })
            return
          }

          const action = getRealNameAction(res.result.authWay, res.result.url)
          if (action === 'qr') {
            realNameQrUrl.value = res.result.url
            realNameQrStatus.value = true
            return
          }
          if (action === 'redirect') window.location.href = res.result.url
        })
        .catch(() => showToast({ message: '获取实名认证入口失败', forbidClick: true }))
      }).catch(() => {
        continueWatchHome()
      })
    }).catch(() => {
      continueWatchHome()
    })
  }

  const refreshCardDataOnReturn = () => {
    if (document.visibilityState !== 'visible') return
    getWifiCustomizationCardQueryCardMsg({ iccid: route.params.iccid })
      .then((res: any) => {
        if (res.code === 200) cardData.value = res.result
      })
  }

  function _getWifiCustomizationCardQueryCardMsg() {
    getWifiCustomizationCardQueryCardMsg({ iccid: route.params.iccid })
      .then((res: any) => {
        console.log(res)
        if (res.code === 200) {
          cardData.value = res.result
          cardDataLoaded.value = true
          store.commit('setKfUrl', res.result.watchesCustomerServiceUrl)
          if (localStorage.getItem("watchPhone")) {
            promptRealNameIfNeeded(res.result)
          } else {
            phoneStatus.value = true
          }
        }
      })
  }

  onMounted(() => {
    document.addEventListener('visibilitychange', refreshCardDataOnReturn)
    if (route.query.hasOwnProperty('userId')) {
      store.commit('setAppid', route.query.mpAppId)
      store.commit('setTenantId', route.query.cmeId)
      store.commit('setUserId', route.query.userId)
      _getWifiCustomizationCardQueryCardMsg()
    } else {
      getWifiLoginAuth(route.params.iccid).then((res: any) => {
        if (res.code === 200) {
          window.location.href = res.result
        } else {
          showToast({ message: res.message, forbidClick: true, });
        }
      })
    }
  })

  onBeforeUnmount(() => {
    document.removeEventListener('visibilitychange', refreshCardDataOnReturn)
  })

return (_ctx: any,_cache: any) => {
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_popup = _resolveComponent("van-popup")!
  const _component_van_field = _resolveComponent("van-field")!
  const _component_van_cell_group = _resolveComponent("van-cell-group")!
  const _component_van_form = _resolveComponent("van-form")!

  return (cardDataLoaded.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("ul", _hoisted_2, [
          _createElementVNode("li", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("img", {
                src: operatorInfo.value.icon,
                alt: "",
                class: "icon"
              }, null, 8, _hoisted_5)
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, _toDisplayString(operatorInfo.value.name), 1),
              _createElementVNode("div", _hoisted_8, "状态：" + _toDisplayString(cardData.value.cardStatus), 1)
            ])
          ]),
          _createElementVNode("li", _hoisted_9, "充值卡号: " + _toDisplayString(cardData.value.iccidShort), 1),
          _createElementVNode("li", _hoisted_10, "ICCID: " + _toDisplayString(_unref(route).params.iccid), 1)
        ]),
        _hoisted_11,
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _hoisted_14,
            _createElementVNode("div", _hoisted_15, _toDisplayString(cardData.value.boundlessFlag ? '不限量': (cardData.value.flowLeave || 0)), 1),
            _hoisted_16
          ]),
          _hoisted_17,
          _createElementVNode("div", _hoisted_18, [
            _hoisted_19,
            _createElementVNode("div", _hoisted_20, _toDisplayString(cardData.value.boundlessFlag ? '不限量': (cardData.value.flowTotal || 0)), 1),
            _hoisted_21
          ])
        ]),
        _hoisted_22,
        _createElementVNode("ul", _hoisted_23, [
          _createElementVNode("li", {
            class: "featureItem",
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (appletStatus.value = true), ["prevent"]))
          }, [
            _hoisted_24,
            _createElementVNode("div", _hoisted_25, _toDisplayString(watchManageLabel.value), 1)
          ]),
          _createElementVNode("li", {
            class: "featureItem",
            onClick: _withModifiers(goPackage, ["prevent"])
          }, _hoisted_29, 8, _hoisted_26),
          _createElementVNode("li", {
            class: "featureItem",
            onClick: goKf
          }, _hoisted_32),
          _createElementVNode("li", {
            class: "featureItem",
            onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (officialStatus.value = true), ["prevent"]))
          }, _hoisted_35)
        ]),
        _createVNode(_component_van_popup, {
          show: appletStatus.value,
          "onUpdate:show": _cache[3] || (_cache[3] = ($event: any) => ((appletStatus).value = $event)),
          round: "",
          "close-on-click-overlay": false
        }, {
          default: _withCtx(() => [
            _hoisted_36,
            _createElementVNode("img", {
              src: miniAppQrCodeUrl.value,
              alt: "",
              class: "popupImg"
            }, null, 8, _hoisted_37),
            _createVNode(_component_van_button, {
              type: "primary",
              onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (appletStatus.value = false), ["prevent"])),
              class: "popupBtn"
            }, {
              default: _withCtx(() => [
                _createTextVNode("关闭")
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["show"]),
        _createVNode(_component_van_popup, {
          show: officialStatus.value,
          "onUpdate:show": _cache[5] || (_cache[5] = ($event: any) => ((officialStatus).value = $event)),
          round: "",
          "close-on-click-overlay": false
        }, {
          default: _withCtx(() => [
            _hoisted_38,
            _createElementVNode("img", {
              src: cardData.value.watchCustomerServiceQrCodeUrl,
              alt: "",
              class: "popupImg"
            }, null, 8, _hoisted_39),
            _createVNode(_component_van_button, {
              type: "primary",
              onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (officialStatus.value = false), ["prevent"])),
              class: "popupBtn"
            }, {
              default: _withCtx(() => [
                _createTextVNode("关闭")
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["show"]),
        _createVNode(_component_van_popup, {
          show: realNameQrStatus.value,
          "onUpdate:show": _cache[6] || (_cache[6] = ($event: any) => ((realNameQrStatus).value = $event)),
          round: ""
        }, {
          default: _withCtx(() => [
            _createElementVNode("img", {
              src: realNameQrUrl.value,
              alt: "",
              class: "popupImg"
            }, null, 8, _hoisted_40)
          ]),
          _: 1
        }, 8, ["show"]),
        _createVNode(_component_van_popup, {
          show: phoneStatus.value,
          "onUpdate:show": _cache[9] || (_cache[9] = ($event: any) => ((phoneStatus).value = $event)),
          round: "",
          "close-on-click-overlay": false
        }, {
          default: _withCtx(() => [
            _hoisted_41,
            _createVNode(_component_van_form, { onSubmit: onSubmit }, {
              default: _withCtx(() => [
                _createVNode(_component_van_cell_group, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_van_field, {
                      modelValue: _unref(phone),
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_isRef(phone) ? (phone).value = $event : phone = $event)),
                      type: "tel",
                      placeholder: "请输入手机号",
                      maxlength: "11",
                      rules: [{ required: true, message: '请输入手机号' }]
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_van_field, {
                      modelValue: _unref(code),
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_isRef(code) ? (code).value = $event : code = $event)),
                      type: "number",
                      placeholder: "请输入短信验证码",
                      maxlength: "4",
                      rules: [{ required: true, message: '请输入短信验证码' }]
                    }, {
                      button: _withCtx(() => [
                        _createVNode(_component_van_button, {
                          size: "small",
                          onClick: getCode,
                          disabled: sendCodeButtonText.value !== '发送验证码',
                          "loading-text": "发送中..."
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(sendCodeButtonText.value), 1)
                          ]),
                          _: 1
                        }, 8, ["disabled"])
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_42, [
                  _createVNode(_component_van_button, {
                    round: "",
                    block: "",
                    type: "primary",
                    "native-type": "submit"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" 校验 ")
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["show"]),
        _createVNode(_component_van_popup, {
          show: experienceStatus.value,
          "onUpdate:show": _cache[10] || (_cache[10] = ($event: any) => ((experienceStatus).value = $event)),
          round: "",
          "close-on-click-overlay": false,
          style: {"background":"transparent"}
        }, {
          default: _withCtx(() => [
            _createElementVNode("img", {
              src: _unref(agentPackageResultVO).packageUrl,
              alt: "",
              class: "popupImg",
              onClick: _withModifiers(claim, ["prevent"])
            }, null, 8, _hoisted_43)
          ]),
          _: 1
        }, 8, ["show"]),
        _createVNode(_component_van_popup, {
          show: experienceAlert.value,
          "onUpdate:show": _cache[12] || (_cache[12] = ($event: any) => ((experienceAlert).value = $event)),
          round: "",
          "close-on-click-overlay": false,
          style: {"background":"transparent"}
        }, {
          default: _withCtx(() => [
            _createElementVNode("img", {
              src: _unref(agentPackageResultVO).orderSuccessUrl,
              alt: "",
              class: "popupImg",
              onClick: _cache[11] || (_cache[11] = _withModifiers(($event: any) => (experienceAlert.value = false), ["prevent"]))
            }, null, 8, _hoisted_44)
          ]),
          _: 1
        }, 8, ["show"])
      ]))
    : _createCommentVNode("", true)
}
}

})